export default __webpack_public_path__ + "static/media/rec.3b074135.png";